import { render, staticRenderFns } from "./createDaliy.vue?vue&type=template&id=9801d34e&"
import script from "./createDaliy.vue?vue&type=script&lang=js&"
export * from "./createDaliy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports